import { render, staticRenderFns } from "./AutobuyerToggles.vue?vue&type=template&id=056b1c4c&scoped=true"
import script from "./AutobuyerToggles.vue?vue&type=script&lang=js"
export * from "./AutobuyerToggles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056b1c4c",
  null
  
)

export default component.exports